import styled from "styled-components/macro";

import { Button } from "components/Button";
import { SortableTable } from "components/SortableTable/SortableTable";
import { StyledCell, StyledHeaderCell } from "components/SortableTable/SortableTable.styled";

import type { ThemeProps } from "models/styles/theme";
import { Heading3 } from "styles/elements/Headings";
import { calculateRem } from "styles/mixins/calculateRem";

export const StyledHeader = styled(Heading3)<ThemeProps>`
  font-weight: ${({ theme }: ThemeProps) => theme.font.weight.normal};
`;

export const StyledTableContainer = styled.div<ThemeProps>`
  border: 1px solid ${({ theme }: ThemeProps) => theme.palette.neutral._900};
  margin-top: ${calculateRem(44)};
  padding: ${calculateRem(16)};
`;

export const StyledTableHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${calculateRem(32)};
`;

export const StyledSortableTable = styled(SortableTable)<ThemeProps>`
  ${StyledHeaderCell} {
    align-items: flex-start;
  }

  .header-cell-email,
  .header-cell-actions {
    align-items: center;
    justify-content: end;
  }

  ${StyledCell} {
    background: ${({ theme }: ThemeProps) => theme.palette.neutral.white};
    svg {
      margin-right: 0.5rem;
    }
  }

  ${StyledCell}:last-child {
    justify-content: flex-end;
  }

`;

export const StyledActionButton = styled(Button)`
  transition: 0.5s;
  color: ${({ theme }: ThemeProps) => theme.palette.secondary.brand};

  :hover {
    color: ${({ theme }: ThemeProps) => theme.palette.secondary._100};
  }

  :disabled {
    color: ${({ theme }: ThemeProps) => theme.palette.neutral._600};

    :hover {
      background: none;
      color: ${({ theme }: ThemeProps) => theme.palette.neutral._600};
    }
  }
`;
